<template>
    <div class="app-background">
      <div class="chats-wrapper">
        <!-- Chat con GPT-3.5 Turbo -->
        <div class="chat-container">
          <h2>Chat con GPT-3.5 Turbo</h2>
          <div class="chat-window">
            <div v-for="(message, index) in messagesTurbo" :key="index" class="chat-message" :class="message.sender == 'Tú' ? 'user-message' : 'bot-message'">
              <strong>{{ message.sender }}:</strong>
              <div v-html="formatMessage(message.text)" />
            </div>
            <div v-if="loadingTurbo" class="loading-message">
              <strong>ChatGPT:</strong> Escribiendo...
            </div>
          </div>
          <div class="input-container">
            <input
              v-model="userMessageTurbo"
              @keyup.enter="sendMessageTurbo"
              type="text"
              placeholder="Escribe tu mensaje..."
            />
            <button @click="sendMessageTurbo">Enviar</button>
          </div>
        </div>
  
        <!-- Chat con GPT-4 -->
        <div class="chat-container">
          <h2>Chat con GPT-4</h2>
          <div class="chat-window">
            <div v-for="(message, index) in messagesGPT4" :key="index" class="chat-message" :class="message.sender == 'Tú' ? 'user-message' : 'bot-message'">
              <strong>{{ message.sender }}:</strong>
              <div v-html="formatMessage(message.text)" />
            </div>
            <div v-if="loadingGPT4" class="loading-message">
              <strong>ChatGPT:</strong> Escribiendo...
            </div>
          </div>
          <div class="input-container">
            <input
              v-model="userMessageGPT4"
              @keyup.enter="sendMessageGPT4"
              type="text"
              placeholder="Escribe tu mensaje..."
            />
            <button @click="sendMessageGPT4">Enviar</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        // Chat con GPT-3.5 Turbo
        userMessageTurbo: '',
        messagesTurbo: [],
        loadingTurbo: false,
  
        // Chat con GPT-4
        userMessageGPT4: '',
        messagesGPT4: [],
        loadingGPT4: false
      };
    },
    methods: {
      formatMessage(text) {
        const codeBlockPattern = /```([a-z]*)\n([\s\S]*?)```/g;
        return text.replace(codeBlockPattern, (match, lang, code) => {
          return `<pre class="code-block"><code>${code.trim()}</code></pre>`;
        });
      },
      async sendMessageTurbo() {
        if (this.userMessageTurbo.trim() == '') return;
  
        this.messagesTurbo.push({ sender: 'Tú', text: this.userMessageTurbo });
        this.loadingTurbo = true;
  
        try {
          const response = await axios.post('/api/chatgpt3', {
            message: this.userMessageTurbo
          });
          console.log(response.data);
  
          if (response.data.choices && response.data.choices.length > 0) {
            this.messagesTurbo.push({ sender: 'ChatGPT', text: response.data.choices[0].message.content });
          } else {
            this.messagesTurbo.push({ sender: 'ChatGPT', text: 'No se recibió respuesta.' });
          }
        } catch (error) {
          console.error('Error enviando el mensaje:', error);
          this.messagesTurbo.push({ sender: 'Error', text: 'No se pudo obtener una respuesta.' });
        } finally {
          this.userMessageTurbo = '';
          this.loadingTurbo = false;
        }
      },
      async sendMessageGPT4() {
        if (this.userMessageGPT4.trim() == '') return;
  
        this.messagesGPT4.push({ sender: 'Tú', text: this.userMessageGPT4 });
        this.loadingGPT4 = true;
  
        try {
          const response = await axios.post('/api/chatgpt4', {
            message: this.userMessageGPT4
          });
  
          console.log(response.data);
          
          if (response.data.choices && response.data.choices.length > 0) {
            this.messagesGPT4.push({ sender: 'ChatGPT', text: response.data.choices[0].message.content });
          } else {
            this.messagesGPT4.push({ sender: 'ChatGPT', text: 'No se recibió respuesta.' });
          }
        } catch (error) {
          console.error('Error enviando el mensaje:', error);
          this.messagesGPT4.push({ sender: 'Error', text: 'No se pudo obtener una respuesta.' });
        } finally {
          this.userMessageGPT4 = '';
          this.loadingGPT4 = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .app-background {
    background-color: #1e1e1e;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  
  .chats-wrapper {
    display: flex;
    gap: 20px;
    justify-content: center;
    width: 100%;
    max-width: 1200px;
  }
  
  .chat-container {
    flex: 1;
    max-width: 50%;
    background-color: #2e2e2e;
    color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
    padding: 20px;
    box-sizing: border-box;
  }
  
  h2 {
    text-align: center;
    color: #ffffff;
    margin-bottom: 20px;
    font-weight: normal;
    font-size: 1.2em;
  }
  
  .chat-window {
    border: 1px solid #444;
    background-color: #3b3b3b;
    padding: 15px;
    margin-bottom: 20px;
    max-height: 400px;
    overflow-y: auto;
    border-radius: 8px;
  }
  
  .chat-message {
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 8px;
    line-height: 1.4em;
  }
  
  .user-message {
    background-color: #4a4a4a;
    text-align: right;
  }
  
  .bot-message {
    background-color: #5a5a5a;
    text-align: left;
  }
  
  .loading-message {
    background-color: #5a5a5a;
    text-align: left;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 8px;
    color: #bbb;
    font-style: italic;
  }
  
  .code-block {
    background-color: #2d2d2d;
    color: #f8f8f2;
    padding: 10px;
    border-radius: 5px;
    overflow-x: auto;
    margin-top: 10px;
    font-family: 'Courier New', Courier, monospace;
    border: 1px solid #444;
  }
  
  .input-container {
    display: flex;
    border-top: 1px solid #444;
    padding-top: 10px;
  }
  
  input {
    flex: 1;
    padding: 10px;
    background-color: #444;
    border: 1px solid #666;
    color: #fff;
    border-radius: 5px;
    margin-right: 10px;
  }
  
  input::placeholder {
    color: #aaa;
  }
  
  button {
    padding: 10px 20px;
    background-color: #1a73e8;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  button:hover {
    background-color: #1669c1;
  }
  
  button:focus {
    outline: none;
  }
  </style>
  